import "../App.css";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import apiBaseUrl from "../apiBase";

// Initialize global variables for links to external pages
const illustrativeURL =
	"https://marc2.org/tr_rtp/pdf/Illustrative_Projects_List_20230426.pdf";
const constrainedURL =
	"https://marc2.org/tr_rtp/pdf/Constrained_Projects_List_20230426.pdf";
const mapURL =
	"https://marc-gis.maps.arcgis.com/home/webmap/viewer.html?webmap=85c5b97c70ac47b7863851f46af4550a";

const getTextValue = (item, keys) => {
	for (const key of keys) {
		const value = item?.[key];
		if (value !== undefined && value !== null) {
			return String(value);
		}
	}
	return "";
};

const toNumberOrNull = (value) => {
	const parsed = Number(value);
	return Number.isNaN(parsed) ? null : parsed;
};

const getCommentProjectId = (comment) =>
	comment?.projectId ??
	comment?.ProjectID ??
	comment?.projectID ??
	comment?.dbID ??
	comment?.DbID ??
	comment?.DBID;

function CurrencyFormatter({ value }) {
	return new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: "USD",
		minimumFractionDigits: 0,
	}).format(value);
}

const returnClick = () => {
	window.history.back();
};

export const ProjectSummary = ({}) => {
	const [data, setData] = useState(null);
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false);
	const [commentdata, setCommentData] = useState(null);

	console.log("dbid: " + sessionStorage.getItem("ProjectNumber"));

	useEffect(() => {
		const fetchData = async () => {
			setLoading(true);
			const selectedProjectId = sessionStorage.getItem("ProjectNumber");
			try {
				const response = await fetch(
					`${apiBaseUrl}/LRTPProject/getbyprojectid?projectid=` +
						selectedProjectId,
				);
				const comments = await fetch(`${apiBaseUrl}/TCPProjectComments`);
				if (!response.ok || !comments.ok) {
					throw new Error(`Error: ${response.statusText}`);
				}
				const data = await response.json();
				const allComments = await comments.json();
				const selectedProjectNumber = toNumberOrNull(selectedProjectId);

				// Keep only comments that belong to the selected project when a project-id field is available.
				const commentdata = Array.isArray(allComments)
					? allComments.filter((comment) => {
							const commentProjectNumber = toNumberOrNull(
								getCommentProjectId(comment),
							);
							return (
								commentProjectNumber === null ||
								commentProjectNumber === selectedProjectNumber
							);
						})
					: allComments;

				setData(data);
				setCommentData(commentdata);
				setLoading(false);
			} catch (error) {
				setError(error);
			}
		};

		fetchData();
	}, []);

	if (loading) return <h1>Loading...</h1>;
	if (error) return <pre>{JSON.stringify(error)}</pre>;
	if (!data) return null;

	const project = Array.isArray(data) ? data[0] : data;
	const commentsList = Array.isArray(commentdata)
		? commentdata
		: commentdata
			? [commentdata]
			: [];

	return (
		<div className="container">
			<div className="listcontainer">
				<img src="https://gis2.marc2.org/assets/CKC/CKC2050Logo.png"></img>
				<nav>
					<div className="nav-row">
						<Link to="/organization">
							<button type="button" className="button-link">
								View by Organization
							</button>
						</Link>
						&nbsp;&nbsp;
						<Link to="/system">
							<button type="button" className="button-link">
								View by System
							</button>
						</Link>
						&nbsp;&nbsp;
						<Link to="/projectmode">
							<button type="button" className="button-current-link">
								View by Primary Project Mode
							</button>
						</Link>
						&nbsp;&nbsp;
						<Link to="/comments">
							<button type="button" className="button-link">
								View Projects with Comments
							</button>
						</Link>
					</div>
					<div className="nav-row">
						<Link to={mapURL} target="_blank" rel="noopener noreferrer">
							<button type="button" className="button-link">
								View Projects on Map
							</button>
						</Link>
						&nbsp;&nbsp;
						<Link
							to={illustrativeURL}
							target="_blank"
							rel="noopener noreferrer"
						>
							<button type="button" className="button-link">
								Illustrative Projects Printable Summary
							</button>
						</Link>
						&nbsp;&nbsp;
						<Link to={constrainedURL} target="_blank" rel="noopener norefferer">
							<button type="button" className="button-link">
								Constrained Projects Printable Summary
							</button>
						</Link>
					</div>
				</nav>
				<br />
				<br />
			</div>
			<div className="project-header-title">
				<h3>{getTextValue(project, ["ProjectName", "projectName"])}</h3>
			</div>
			<div className="project-header-subhead">
				<div className="project-header-organization">
					<h4>
						{getTextValue(project, [
							"Organization",
							"organization",
							"Sponsor",
							"sponsor",
						])}
					</h4>
				</div>
				<div className="project-header-return">
					<button
						className="button-return"
						type="button"
						onClick={() => returnClick()}
					>
						Back
					</button>
				</div>
			</div>
			<div className="project-spacer">&nbsp;&nbsp;</div>
			<br />
			<table>
				{/* <thead>
                    <tr colSpan={2}><th colSpan={2}>{data[0].ProjectName}</th></tr>
                    <tr colSpan={2}><th colSpan={2}><hr /></th></tr>
                    <tr colSpan={2}><th colSpan={2}><hr /></th></tr>
                </thead> */}
				<tbody>
					<tr>
						<td width={200}>Project ID: </td>
						<td>{project?.ProjectID ?? project?.projectId}</td>
					</tr>
					<tr>
						<td>Sponsor: </td>
						<td>{getTextValue(project, ["Sponsor", "sponsor"])}</td>
					</tr>
					<tr>
						<td>Project Name: </td>
						<td>{getTextValue(project, ["ProjectName", "projectName"])}</td>
					</tr>
					<tr>
						<td>Primary Project Mode: </td>
						<td>{getTextValue(project, ["PrimaryMode", "primaryMode"])}</td>
					</tr>
					<tr>
						<td>Project Purpose: </td>
						<td>{getTextValue(project, ["Purpose", "purpose"])}</td>
					</tr>
					<tr>
						<td>Intent: </td>
						<td>{getTextValue(project, ["Intent", "intent"])}</td>
					</tr>
					<tr>
						<td>Scope: </td>
						<td>{getTextValue(project, ["Scope", "scope"])}</td>
					</tr>
					<tr>
						<td>Sponsor: </td>
						<td>{getTextValue(project, ["Sponsor", "sponsor"])}</td>
					</tr>

					<tr>
						<td>Total Budget: </td>
						<td>
							<CurrencyFormatter
								value={project?.BudgetDollars ?? project?.budgetDollars ?? 0}
							/>
						</td>
					</tr>
					<tr>
						<td>Decade: </td>
						<td>{project?.Decade ?? project?.decade}</td>
					</tr>
					<tr>
						<td>Application Score: </td>
						<td>{project?.Score ?? project?.score}</td>
					</tr>
					<tr>
						<td>Constrained/Illustrative: </td>
						<td>
							{getTextValue(project, [
								"ConstrainedIllustrative",
								"constrainedIllustrative",
							])}
						</td>
					</tr>
					<tr>
						<td>Priority: </td>
						<td>{getTextValue(project, ["Priority", "priority"])}</td>
					</tr>
					<tr>
						<td>Adds Capacity: </td>
						<td>{getTextValue(project, ["CapacityAdded", "capacityAdded"])}</td>
					</tr>
				</tbody>
			</table>
			<br />

			{/* This is the code to display the project comments */}
			<div className="comment-header">
				<h3>Submitted Comments:</h3>
			</div>
			<div className="comment-notes">
				Please note, only public comments are available for review, which may
				differ from the total shown on the project listing page.
			</div>
			{commentsList.map((comment) => (
				<div
					key={comment.CommentID ?? comment.commentID ?? comment.id}
					className="comment-spacer"
				>
					<div className="comment-user">
						{getTextValue(comment, ["Name", "name"])} said...
					</div>
					<div className="comment-comment">
						{getTextValue(comment, ["Comment", "comment"])}
					</div>
				</div>
			))}
			<div className="project-footer">
				<div className="project-footer-return">
					<button
						className="button-return"
						type="button"
						onClick={() => returnClick()}
					>
						Back
					</button>
				</div>
			</div>
			<div className="project-footer-info">
				<div className="project-footer-address">
					600 Broadway
					<br />
					Kansas City, MO 64105
					<br />
					816/474-4240
					<br />
					Fax 816/421-7758
				</div>
				<div className="project-footer-dc">
					MARC programs that receive federal funding may not discriminate
					against anyone on the basis of race, color or national origin,
					according to Title VI of the Civil Rights Act of 1964.
					<br />
					<a href="https://www.marc.org/ADA">
						Americans with Disabilities Act
					</a>{" "}
					| <a href="https://test.marc.org">Title VI policy</a>
				</div>
			</div>
		</div>
	);
};

export default ProjectSummary;
